/** Core Requirements */
export const CoreReqs = [
    "ENGL 110",
    "EGGG 101",
    "CISC 181",
    "CISC 210",
    "CISC 220",
    "CISC 260",
    "CISC 275",
    "CISC 303",
    "CISC 320",
    "CISC 355",
    "MATH 210",
    "MATH 241"
];

export const introCisc = ["CISC 106", "CISC 108"];
export const statReqs = ["MATH 205", "MATH 350"];
export const writingReqs = ["ENGL 312", "ENGL 410"];
export const capstoneReqs = ["CISC 498", "CISC 499", "UNIV 401", "UNIV 402"];
export const labScienceReqs = [
    "PHYS 207",
    "PHYS 227",
    "PHYS 208",
    "PHYS 228",
    "CHEM 103",
    "CHEM 133",
    "CHEM 104",
    "CHEM 134",
    "BISC 207",
    "BISC 208",
    "GEOL 105",
    "GEOL 115",
    "GEOL 107",
    "GEOL 110"
];

/** Concentration Requirements */
export const AI = ["CISC 304", "CISC 442", "CISC 481", "CISC 483", "CISC 484"];

export const BioinformaticsReqs = [
    "BISC 207",
    "BISC 208",
    "BISC 401",
    "CHEM 103",
    "CHEM 133",
    "CHEM 104",
    "CHEM 134",
    "CISC 372",
    "CISC 436",
    "MATH 242",
    "MATH 349"
];

export const CybersecurityReqs = [
    "CISC 361",
    "CISC 372",
    "CISC 450",
    "CISC 464",
    "CPEG 465",
    "CPEG 494"
];

export const DataScienceReqs = [
    "CISC 304",
    "CISC 372",
    "CISC 437",
    "CISC 481",
    "MATH 205",
    "MATH 242",
    "MATH 243",
    "MATH 349"
];

export const HighPerformanceComputingReqsApplied = [
    "CISC 360",
    "CISC 361",
    "CISC 372",
    "CISC 450",
    "CISC 471",
    "MATH 242",
    "MATH 243",
    "MATH 351",
    "MATH 428"
];

export const HighPerformanceComputingReqsData = [
    "CISC 360",
    "CISC 361",
    "CISC 372",
    "CISC 450",
    "CISC 471",
    "MATH 242",
    "MATH 243",
    "CISC 437",
    "MATH 350",
    "MATH 450"
];

export const SystemsandNetworksReqs = [
    "CISC 360",
    "CISC 361",
    "CISC 372",
    "CISC 450",
    "CISC 471"
];

export const TheoryandComputationReqsContinous = [
    "CISC 304",
    "CISC 401",
    "MATH 242",
    "MATH 349",
    "MATH 243",
    "MATH 302",
    "MATH 535",
    "MATH 426"
];

export const TheoryandComputationReqsDiscreet = [
    "CISC 304",
    "CISC 401",
    "MATH 242",
    "MATH 349",
    "CISC 404",
    "MATH 245",
    "MATH 315",
    "MATH 451"
];

export const Concentration = [
    AI,
    BioinformaticsReqs,
    CybersecurityReqs,
    DataScienceReqs,
    HighPerformanceComputingReqsApplied,
    HighPerformanceComputingReqsData,
    SystemsandNetworksReqs,
    TheoryandComputationReqsContinous,
    TheoryandComputationReqsDiscreet
];

/** Breadth Requirements */
export const multiCultReqs = [
    "AFRA 110",
    "AFRA 193",
    "AFRA 205",
    "AFRA 206",
    "AFRA 220",
    "AFRA 221",
    "AFRA 222",
    "AFRA 223",
    "AFRA 225",
    "AFRA 250",
    "AFRA 251",
    "AFRA 304",
    "AFRA 305",
    "AFRA 306",
    "AFRA 314",
    "AFRA 315",
    "AFRA 318",
    "AFRA 320",
    "AFRA 321",
    "AFRA 325",
    "AFRA 329",
    "AFRA 334",
    "AFRA 362",
    "AFRA 370",
    "AFRA 371",
    "AFRA 372",
    "AFRA 373",
    "AFRA 381",
    "AFRA 398",
    "AFRA 434",
    "AFRA 440",
    "AFRA 442",
    "AFRA 443",
    "AFRA 445",
    "AFRA 446",
    "AFRA 447",
    "AFRA 484",
    "ANFS 100",
    "ANFS 102",
    "ANTH 101",
    "ANTH 103",
    "ANTH 201",
    "ANTH 209",
    "ANTH 210",
    "ANTH 211",
    "ANTH 212",
    "ANTH 223",
    "ANTH 228",
    "ANTH 229",
    "ANTH 230",
    "ANTH 232",
    "ANTH 233",
    "ANTH 234",
    "ANTH 235",
    "ANTH 236",
    "ANTH 239",
    "ANTH 245",
    "ANTH 265",
    "ANTH 269",
    "ANTH 310",
    "ANTH 312",
    "ANTH 318",
    "ANTH 320",
    "ANTH 321",
    "ANTH 325",
    "ANTH 326",
    "ANTH 330",
    "ANTH 333",
    "ANTH 343",
    "ANTH 344",
    "ANTH 351",
    "ANTH 352",
    "ANTH 354",
    "ANTH 356",
    "ANTH 360",
    "ANTH 372",
    "ANTH 375",
    "ANTH 381",
    "ANTH 383",
    "ANTH 401",
    "APEC 100",
    "ARAB 208",
    "ART 204 ",
    "ART 324 ",
    "ART 407 ",
    "ARTC 110",
    "ARTH 101",
    "ARTH 151",
    "ARTH 153",
    "ARTH 163",
    "ARTH 164",
    "ARTH 175",
    "ARTH 204",
    "ARTH 210",
    "ARTH 228",
    "ARTH 229",
    "ARTH 232",
    "ARTH 233",
    "ARTH 237",
    "ARTH 246",
    "ARTH 248",
    "ARTH 299",
    "ARTH 303",
    "ARTH 311",
    "ARTH 323",
    "ARTH 332",
    "ARTH 333",
    "ARTH 380",
    "ARTH 419",
    "ARTH 440",
    "ARTH 444",
    "ARTH 445",
    "ARTH 456",
    "BHAN 236",
    "BHAN 322",
    "BISC 127",
    "DIST 250",
    "CHIN 204",
    "CHIN 451",
    "CHIN 452",
    "CIEG 492",
    "COMM 204",
    "COMM 263",
    "COMM 421",
    "CRJU 350",
    "CRJU 355",
    "CRJU 452",
    "ECON 311",
    "ECON 418",
    "EDUC 247",
    "EDUC 258",
    "EDUC 419",
    "EDUC 459",
    "ENGL 215",
    "ENGL 216",
    "ENGL 278",
    "ENGL 345",
    "ENGL 350",
    "ENGL 376",
    "ENGL 380",
    "ENGL 381",
    "ENGL 382",
    "ENWC 413",
    "FASH 213",
    "FASH 319",
    "FREN 207",
    "FREN 457",
    "FREN 458",
    "GAME 352",
    "GEOG 102",
    "GEOG 120",
    "GEOG 203",
    "GEOG 226",
    "GEOG 310",
    "GEOG 430",
    "GEOG 450",
    "HDFS 202",
    "HDFS 203",
    "HIST 103",
    "HIST 104",
    "HIST 130",
    "HIST 131",
    "HIST 134",
    "HIST 135",
    "HIST 137",
    "HIST 138",
    "HIST 139",
    "HIST 140",
    "HIST 145",
    "HIST 146",
    "HIST 224",
    "HIST 300",
    "HIST 304",
    "HIST 327",
    "HIST 335",
    "HIST 364",
    "HIST 368",
    "HIST 369",
    "HIST 370",
    "HIST 371",
    "HIST 377",
    "HIST 378",
    "HIST 380",
    "HIST 381",
    "HIST 388",
    "HIST 390",
    "HIST 392",
    "HIST 395",
    "HIST 397",
    "HIST 439",
    "HIST 444",
    "HIST 460",
    "HIST 477",
    "HLPR 233",
    "HLTH 245",
    "HLTH 315",
    "HOSP 214",
    "HOSP 316",
    "HOSP 317",
    "HOSP 328",
    "HOSP 330",
    "HOSP 355",
    "JAPN 208",
    "LARC 202",
    "LING 101",
    "LING 102",
    "LING 203",
    "LING 222",
    "LING 480",
    "LLCU 207",
    "LLCU 332",
    "LLCU 333",
    "LLCU 335",
    "LLCU 345",
    "MAST 202",
    "MAST 375",
    "MUSC 205",
    "MUSC 227",
    "MUSC 302",
    "MUSC 438",
    "NTDT 301",
    "NTDT 475",
    "NURS 235",
    "NURS 412",
    "NURS 414",
    "PHIL 204",
    "PHIL 208",
    "PHIL 307",
    "PHIL 309",
    "PHIL 310",
    "PHIL 327",
    "PHIL 335",
    "PHIL 337",
    "PHIL 338",
    "PHIL 410",
    "PLSC 100",
    "POSC 230",
    "POSC 322",
    "POSC 361",
    "POSC 406",
    "POSC 412",
    "POSC 422",
    "POSC 433",
    "POSC 455",
    "RUSS 325",
    "SOCI 213",
    "SOCI 471",
    "SPAN 207",
    "SPAN 208",
    "SPAN 326",
    "SPAN 447",
    "SPAN 471",
    "SPAN 472",
    "SPAN 473",
    "SPAN 474",
    "SPAN 479",
    "SPAN 491",
    "SPTM 318",
    "SPTM 416",
    "THEA 240",
    "THEA 241",
    "THEA 340",
    "UAPP 449",
    "WOMS 200",
    "WOMS 201",
    "WOMS 202",
    "WOMS 209",
    "WOMS 210",
    "WOMS 212",
    "WOMS 214",
    "WOMS 216",
    "WOMS 240",
    "WOMS 284",
    "WOMS 304",
    "WOMS 306",
    "WOMS 314",
    "WOMS 332",
    "WOMS 336",
    "WOMS 341",
    "WOMS 356"
];
